import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';

interface IHeaderLayoutContextValue {
  title: string;
  actions: ReactNode;
  setHeader: (value: { title?: string; actions?: ReactNode }) => void;
  resetHeader: () => void;
}

export const HeaderLayoutContext = createContext<IHeaderLayoutContextValue>(
  {} as IHeaderLayoutContextValue,
);

export function HeaderLayoutProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string>('');
  const [actions, setActions] = useState<ReactNode>(null);

  const setHeader = useCallback(
    (value: { title?: string; actions?: ReactNode }) => {
      if (value.title !== undefined) setTitle(value.title);
      if (value.actions !== undefined) setActions(value.actions);
    },
    [],
  );

  const resetHeader = useCallback(() => {
    setTitle('');
    setActions(null);
  }, []);

  const value = useMemo(
    () => ({ title, actions, setHeader, resetHeader }),
    [title, actions, setHeader, resetHeader],
  );

  return (
    <HeaderLayoutContext.Provider value={value}>
      {children}
    </HeaderLayoutContext.Provider>
  );
}
